import { render, staticRenderFns } from "./FerryEdit.vue?vue&type=template&id=1f8d6788"
import script from "@/controllers/custom/ferry/ferry-edit.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/ferry/ferry-edit.js?vue&type=script&lang=js&external"
import style0 from "./FerryEdit.vue?vue&type=style&index=0&id=1f8d6788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports